'use strict';

var bootstrapVue = require('bootstrap-vue');

//
var script = {
  name: "Button",
  components: {
    BButton: bootstrapVue.BButton
  },
  props: {
    showLoader: {
      type: Boolean,
      "default": false
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("b-button", _vm._g(_vm._b({
    "class": {
      loading: _vm.showLoader
    }
  }, "b-button", _vm.$attrs, false), _vm.$listeners), [_vm.showLoader ? _c("i", {
    staticClass: "fa fa-circle-o-notch fa-spin spinner"
  }) : _vm._e(), _vm._v(" "), _c("span", {
    staticClass: "text"
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-f27df7a0_0", {
    source: ".loading[data-v-f27df7a0] {\n  position: relative;\n}\n.loading .text[data-v-f27df7a0] {\n  visibility: hidden;\n}\n.loading .spinner[data-v-f27df7a0] {\n  left: 50%;\n  margin: -7px 0 0 -7px;\n  position: absolute;\n  top: 50%;\n}\n\n/*# sourceMappingURL=Button.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/circleci/project/packages/button/Button.vue", "Button.vue"],
      "names": [],
      "mappings": "AAyBA;EACA,kBAAA;ACxBA;AD0BA;EACA,kBAAA;ACxBA;AD2BA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;ACzBA;;AAEA,qCAAqC",
      "file": "Button.vue",
      "sourcesContent": ["<template>\n  <b-button v-bind=\"$attrs\" :class=\"{ loading: showLoader }\" v-on=\"$listeners\">\n    <i v-if=\"showLoader\" class=\"fa fa-circle-o-notch fa-spin spinner\" />\n    <span class=\"text\">\n      <slot />\n    </span>\n  </b-button>\n</template>\n\n<script>\nimport { BButton } from \"bootstrap-vue\";\n\nexport default {\n  name: \"Button\",\n  components: { BButton },\n  props: {\n    showLoader: {\n      type: Boolean,\n      default: false\n    }\n  }\n};\n</script>\n\n<style lang=\"scss\" scoped>\n.loading {\n  position: relative;\n\n  .text {\n    visibility: hidden;\n  }\n\n  .spinner {\n    left: 50%;\n    margin: -7px 0 0 -7px;\n    position: absolute;\n    top: 50%;\n  }\n}\n</style>\n", ".loading {\n  position: relative;\n}\n.loading .text {\n  visibility: hidden;\n}\n.loading .spinner {\n  left: 50%;\n  margin: -7px 0 0 -7px;\n  position: absolute;\n  top: 50%;\n}\n\n/*# sourceMappingURL=Button.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = "data-v-f27df7a0";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

var Button = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, browser, undefined);

module.exports = Button;
